var React = require('react');

function X (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M-12-12h40v40h-40z","key":0}),React.createElement("path",{"fill":"#FFF","d":"M1.636.222l14.142 14.142-1.414 1.414L.222 1.636z","key":1}),React.createElement("path",{"fill":"#FFF","d":"M15.778 1.636L1.636 15.778.222 14.364 14.364.222z","key":2})]));
}

X.defaultProps = {"width":"16","height":"16"};

module.exports = X;

X.default = X;
